/**
 * Describes available statuses for a processed genetic file.
 */
export enum ProcessedGeneticFileStatus {
  /**
   * The file was uploaded successfully and saved on backend.
   * Reaching this status means that file passes frontend & backend file format validations.
   */
  UPLOADED = 200,

  /**
   * File was converted to correct format for analysis run.
   * Reaching this status means that file have correct structure and data.
   * File data will be extracted soon (usually takes up to a few minutes).
   */
  CONVERTED = 201,

  /**
   * File data was extracted correctly.
   * Reaching this status means that analysis is finished and an account contains all necessary data for genetics display.
   */
  EXTRACTED = 202,
}

/** Describes model for processing step data. */
export interface GeneticFileProcessingStatus {
  /** Unique file identifier saved on backend. */
  id: number;

  /** Status of the processing step of the file. */
  pipeline_type: ProcessedGeneticFileStatus;

  /** When the file was added. Date format: ISO 8601.  */
  added_at: string;
}
